import { memo } from 'react'
import { Link as MuiLink } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import { partnersNavigationData } from '@/assets'
import { Box } from '@/components/Layout'
import { Text } from '@/components/Data'

import { partnersStyles as styles } from './Partners.styles'

interface PartnersProps {
  closeDrawer: (currentState: boolean) => void
}

const Partners = ({ closeDrawer }: PartnersProps) => {
  return (
    <Box sx={styles.container}>
      {partnersNavigationData.map((partner) => (
        <MuiLink
          component={RouterLink}
          onClick={() => closeDrawer(false)}
          to={partner.link}
          key={partner.name}
          sx={styles.listItem}>
          <Box sx={{ ...styles.colorBar, backgroundColor: partner.primaryColor }} />
          <Text sx={styles.partnerName} className="ellipsis">
            {partner.name}
          </Text>
        </MuiLink>
      ))}
    </Box>
  )
}

export default memo(Partners)
